<template>
  <div v-if="messages" class="col-xs-12 q-mb-lg">
    <component
      :is="isEditModalActive"
      v-model="editModal"
      :edit-item="activePeriod"
      :product="subscription.product"
      style="position: absolute"
    />

    <p v-for="(message, index) of messages" :key="`message_${index}`" class="text-subtitle-1 text-secondary-1">
      {{ message }}
    </p>
    <div v-if="config" class="flex q-gutter-sm">
      <q-btn
        v-for="(action, index) of config"
        :key="`milestone_action_${index}`"
        :to="MILESTONE_ACTIONS[action].route"
        :label="MILESTONE_ACTIONS[action].label"
        size="sm"
        color="tertiary"
        @click="manageEvent(MILESTONE_ACTIONS[action].event)"
      />
    </div>
    <slot name="actions">
      <!--keep this for custom actions-->
    </slot>
  </div>
</template>

<script>
// Libraries
import { mapGetters } from 'vuex'

export default {
  name: 'MilestoneMessages',

  components: {
    EditSubscriptionModal: () =>
      import('@/modules/show-page-subscription/components/EditSubscriptionModal/EditSubscriptionModal.vue')
  },

  props: {
    messages: {
      type: [Array, null],
      required: true
    },
    config: {
      type: [Array, null],
      default: () => []
    },
    subscriptionPeriodId: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    editModal: false
  }),

  computed: {
    ...mapGetters('subscription-show', ['subscriptionPeriods', 'subscription']),

    activePeriod() {
      return this.subscriptionPeriods.find(period => period.id === this.subscriptionPeriodId)
    },

    isEditModalActive() {
      if (this.editModal) return 'EditSubscriptionModal'
      return null
    }
  },

  methods: {
    manageEvent(event) {
      if (!event) return
      this[`${event}`]()
    },

    openEditSubPeriodModal() {
      this.editModal = true
    }
  }
}
</script>
